const getters = {
    token: state => state.login.token,
    metadata: state => state.metadata.metadata,
    deviceId: state => state.login.deviceid,
    defaultToken: state => state.user.default_token,
    pointSetting: state => state.user.pointSetting,
    userDetail: state => state.user.userDetail,
    messages: state => state.message.messages,
    profileTemplate: state => state.profile.template,
    isFooter: state => state.layout.isFooter,
    isHeader: state => state.layout.isHeader,
    socketClient: state => state.socket.socket_client,
    routeLoading: state => state.route.routeLoading,
    myTimelines: state => state.timeline.myTimelines,
}
export default getters